import { Injectable } from '@angular/core';
import { FileType } from '../shared/models/file-item.model';
import { OperationStream } from '../shared/models/operation-stream.model';
import { MruData } from '../shared/mru/mru-data.service';
import { OfficeFeedFactoryService } from './officefeed-factory.service';

@Injectable({
    providedIn: 'root',
    useFactory: (officefeedServiceFactory: OfficeFeedFactoryService) => officefeedServiceFactory.getOfficeFeedService(),
    deps: [
        OfficeFeedFactoryService
    ]
})
export abstract class OfficeFeedDataService {
    public abstract getOfficeFeed(): OperationStream<MruData>;

    public abstract logInstrumentation(feedbackIds: Array<string>, actions: Array<string>, itemSource: Array<string>, target?: Array<string>);

    public abstract getStreamsThumbnail(url: string): Promise<string>;

    public abstract performAction(feedbackIds: string, actions: string, actionPayload: string): Promise<boolean>;

    public abstract getTamyDocuments(count: number, types?: Set<FileType>): OperationStream<MruData>;
}
